import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "arrow", "autofill", "big", "disabled", "error", "fieldTooltip", "hasFluidWidth", "iconColorToken", "iconColorTokenArgs", "icon", "id", "onActive", "onBlur", "onClick", "onFocus", "UNSAFE_containerProps", "warning", "withPadding"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect, useRef, useState } from 'react';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import TouchableIcon from '@bubble-ui/molecule-touchable-icon';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import View from '@bubble-ui/primitive-view';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { getIconType } from './utils';
import { TooltipPortal } from './TooltipPortal';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
function FieldTooltip(_ref) {
  var {
      ariaLabel,
      arrow,
      autofill,
      big,
      disabled,
      error,
      fieldTooltip,
      hasFluidWidth,
      iconColorToken,
      iconColorTokenArgs,
      icon,
      id,
      onActive,
      onBlur,
      onClick,
      onFocus,
      UNSAFE_containerProps,
      warning,
      withPadding
      /**
       * @deprecated props spreading for this component will be removed with v6.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'FieldTooltip',
    propName: 'onClick',
    shouldWarn: onClick !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'FieldTooltip',
    propName: 'big',
    shouldWarn: big !== undefined,
    removalDate: 'v6.0.0'
  });
  var parentRef = useRef(null);
  var designContext = useDesignContext(defaultColorVariables);
  var ids = getIds(id);
  var [active, setActive] = useState(false);
  var [interactiveState, eventHandlers] = useInteractiveStateCombined(_objectSpread(_objectSpread({}, props), {}, {
    disabled
  }));
  useEffect(() => {
    var newActive = Boolean(interactiveState.hovered || interactiveState.keyboardFocused);
    if (active !== newActive) {
      setActive(newActive);
      // @ts-expect-error
      onActive(newActive);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interactiveState.hovered, interactiveState.keyboardFocused]);

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    rootStyle,
    iconStyle,
    hoverElementStyle,
    tooltipStyle
  } = useStyleSheet(FieldTooltip, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    ariaLabel,
    active,
    arrow,
    autofill,
    big,
    error,
    fieldTooltip,
    hasFluidWidth,
    iconColorToken,
    iconColorTokenArgs,
    icon,
    id,
    ids,
    onActive,
    onBlur,
    onClick,
    onFocus,
    UNSAFE_containerProps,
    warning,
    withPadding
  }, interactiveState));
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root
  }, UNSAFE_containerProps, {
    style: rootStyle
  }, props, eventHandlers, {
    // To make sure that we can activate & deactivate the tooltip via touch:
    onTouchStart: undefined,
    onTouchEnd: undefined
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.iconWrapper,
    style: iconStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    Icon: getIconType({
      error,
      Icon: icon,
      warning
    }),
    id: ids === null || ids === void 0 ? void 0 : ids.icon,
    onFocus: onFocus,
    onBlur: onBlur,
    colorToken: iconColorToken ? iconColorToken : error || warning || interactiveState.disabled || autofill ? 'colors/text/default' : 'colors/text/neutral',
    colorTokenArgs: iconColorToken ? iconColorTokenArgs : {},
    ariaLabel: ariaLabel
  }))), /*#__PURE__*/React.createElement("span", {
    id: ids === null || ids === void 0 ? void 0 : ids.span,
    style: hoverElementStyle,
    ref: parentRef
  }), active && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.tooltipWrapper,
    style: tooltipStyle
  }, /*#__PURE__*/React.createElement(TooltipPortal, {
    parentRef: parentRef,
    hasFluidWidth: hasFluidWidth,
    arrow: arrow,
    id: ids === null || ids === void 0 ? void 0 : ids.tooltip
  }, fieldTooltip)));
}
FieldTooltip.displayName = 'Field.FieldTooltip';
export default withProvisionalOverrideFromContext(FieldTooltip);
//# sourceMappingURL=index.js.map